import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  TitleTemplatePure,
  Container,
  Stepper,
  SimpleLoading,
  SubtitlePageHLPure,
  PromotionalFooterPure,
} from "../../pures";
import { Grid } from "@material-ui/core";

import './contracting-registration.view.css'



const ContractingRegistrationView = (props) => {
  const { t } = useTranslation();
  const { selectedStep, stepMetadata, steps, loading, validator, setDocumentsSeleceted, user, clientId, titleView } = props;
  const step = steps[selectedStep];
  const [typePersonId, setTypePersonId] = useState(1)
  const [contractWorkFlow, setContractWorkFlow] = useState({})
  const { component: StepComponent, back, next } = stepMetadata[selectedStep];

  return (
    <div className="contractingRegistrationView-container">
      <SubtitlePageHLPure
        subtitle={titleView}
        tooltipShow = {false}
        informationIcon = {false}
      />
      <div>
        <Stepper steps={steps} selectedStep={selectedStep} />
      </div>
      <div className="container-step-sigatureRequestProfile">
        {loading ? (
          <div className="step-description-sigatureRequestProfile">
            <SimpleLoading />
          </div>
        ) : (
          <StepComponent
            step={step}
            onHandleNext={next}
            onHandleBack={back}
            validator = {validator}
            toggleLoadingRequesting = {props.toggleLoadingRequesting}
            toggleCompletedRequesting = {props.toggleCompletedRequesting}
            toggleErrorRequesting = {props.toggleErrorRequesting}
            setDocumentsSeleceted = {setDocumentsSeleceted}
            setContractorClientDocuments = {props.setContractorClientDocuments}
            setTypePersonId = {setTypePersonId}
            typePersonId = {typePersonId}
            setContractWorkFlow = {setContractWorkFlow}
            contractWorkFlow = {contractWorkFlow}
            {...props}
          />
        )}
      </div>
      <Grid item xs={12} lg={12} md={12} sm={12}>
        <PromotionalFooterPure />
      </Grid>
    </div>
  );
};

export { ContractingRegistrationView as default };
